import type { StudioOptionsResponseDto } from '@lunary/api-client'
import { Select } from '@lunary/ui-web/select'
import styles from './studio.module.css'

export type ChatSettings = { model: string; persona_version: number; chat_version: number }

type Props = {
  readonly value: ChatSettings
  readonly options: StudioOptionsResponseDto
  readonly onChange: (next: ChatSettings) => void
}

const suffix = (active: boolean) => (active ? ' · сейчас в проде' : '')

export function ChatSettingsBar({ value, options, onChange }: Props) {
  return (
    <div className={styles.controls}>
      <label>
        Модель
        <Select
          aria-label="Модель"
          className={styles.wide}
          value={value.model}
          options={options.models.map((m) => ({ value: m, label: `${m}${suffix(m === options.default_model)}`, short: m }))}
          onChange={(m) => onChange({ ...value, model: m })}
        />
      </label>
      <label>
        Персона
        <Select
          aria-label="Персона"
          value={`v${value.persona_version}`}
          options={options.persona_versions.map((v) => ({ value: `v${v}`, label: `v${v}${suffix(v === options.active_persona)}`, short: `v${v}` }))}
          onChange={(v) => onChange({ ...value, persona_version: Number(v.slice(1)) })}
        />
      </label>
      <label>
        Задача «диалог»
        <Select
          aria-label="Задача «диалог»"
          value={`v${value.chat_version}`}
          options={options.chat_versions.map((v) => ({ value: `v${v}`, label: `v${v}${suffix(v === options.active_chat)}`, short: `v${v}` }))}
          onChange={(v) => onChange({ ...value, chat_version: Number(v.slice(1)) })}
        />
      </label>
    </div>
  )
}
